import { Check, X } from 'lucide-react';

const rules = [
  { key: 'length', label: 'At least 12 characters', test: (p: string) => p.length >= 12 },
  { key: 'upper', label: '1 uppercase letter', test: (p: string) => /[A-Z]/.test(p) },
  { key: 'lower', label: '1 lowercase letter', test: (p: string) => /[a-z]/.test(p) },
  { key: 'number', label: '1 number', test: (p: string) => /[0-9]/.test(p) },
  { key: 'special', label: '1 special character', test: (p: string) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(p) },
];

export function isPasswordStrong(password: string): boolean {
  return rules.every(r => r.test(password));
}

export default function PasswordChecklist({ password }: { password: string }) {
  if (!password) return null;

  return (
    <div className="space-y-1 pt-1" data-testid="password-checklist">
      {rules.map(({ key, label, test }) => {
        const met = test(password);
        return (
          <div key={key} className="flex items-center gap-1.5 text-xs" data-testid={`pw-rule-${key}`}>
            {met ? (
              <Check className="h-3 w-3 text-[#cafd00] shrink-0" />
            ) : (
              <X className="h-3 w-3 text-[#a8abb3] shrink-0" />
            )}
            <span className={met ? 'text-[#cafd00]' : 'text-[#a8abb3]'}>{label}</span>
          </div>
        );
      })}
    </div>
  );
}
